import { render, staticRenderFns } from "./aRmsDayGeneralPickupColumns.vue?vue&type=template&id=095d238f&scoped=true"
import script from "./aRmsDayGeneralPickupColumns.vue?vue&type=script&lang=js"
export * from "./aRmsDayGeneralPickupColumns.vue?vue&type=script&lang=js"
import style0 from "./aRmsDayGeneralPickupColumns.vue?vue&type=style&index=0&id=095d238f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095d238f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
